import { useQuery } from 'react-query'
import { PaginatedRequest } from '../../../core/interfaces'
import { OpportunityNexContactFilter } from '../../../entities'
import { getOpportunityNexContact } from '../../opportunities'

export default function useOpportunityNexContact(
  query: PaginatedRequest<OpportunityNexContactFilter>
) {
  const { data, error, isLoading } = useQuery(
    ['opportunityNexContact', query],
    () => getOpportunityNexContact(query)
  )
  return { data, error, isLoading }
}
